export default "__VITE_ASSET__C_1fPGa7__"